// Disabling eslint in this file because Downshift handles all the accessibility concerns
/* eslint-disable react/button-has-type */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useSelect } from "downshift";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown } from "@fortawesome/free-solid-svg-icons";

/** Use to create custom styled select lists for UI components. This component uses Downshift from Paypal to create accessible select lists. */
const SelectList = ({
  label,
  initialInputValue,
  isEditable = true,
  hasButton = true,
  classList = "",
  buttonText = "Done",
  sendItem = () => {},
  children: items,
  initialIndex = -1
}) => {
  const isInitialSelected = !!items[initialIndex];
  const [hasSelected, setSelected] = useState(false);

  const itemToString = (item) => item.key;
  /** Uses Downshift's internal state to send the selected item back to the parent element. */
  const handleChange = (item) => {
    if (!hasSelected) {
      setSelected(true);
    }
    sendItem(item.selectedItem);
  };

  const initialItemProp = items[initialIndex] ? { initialSelectedItem: items[initialIndex] } : {};
  const selectProps = {
    ...{
      items,
      itemToString,
      onSelectedItemChange: handleChange
    },
    ...initialItemProp
  };

  const {
    getItemProps,
    getLabelProps,
    getMenuProps,
    getToggleButtonProps,
    isOpen,
    highlightedIndex,
    closeMenu,
    openMenu,
    selectedItem
  } = useSelect(selectProps);

  /**
   * Renders the list of items
   *
   * @returns {HTMLElement} Wraps each child element in an <li> and adds the active class to the currently selected item.
   */
  const renderListItems = () => {
    return items.map((item, index) => {
      const highlightedClassName = highlightedIndex === index ? "is-highlighted" : "";
      let activeClass = "";
      if (selectedItem) {
        activeClass = selectedItem.key === item.key ? "is-active" : "";
      }

      return (
        <li
          className={`select-list__item ${activeClass} ${highlightedClassName}`}
          key={`${item.key}`}
          {...getItemProps({
            key: item.key,
            item,
            index,
            style: {
              backgroundColor: highlightedIndex === index ? "#d9f3f7" : ""
            }
          })}
        >
          {item}
        </li>
      );
    });
  };

  /**
   * Uses Downshift's internal state to determine whether to render a done button or an icon.
   *
   * @returns
   */
  const renderToggleButton = () => {
    if (isOpen && hasButton) {
      return (
        <button
          className="select-list__button select-list__button--open btn btn-primary"
          {...getToggleButtonProps()}
          onClick={() => closeMenu()}
        >
          {buttonText}
        </button>
      );
    }

    if (!isOpen) {
      return (
        <span className="select-list__button">
          <FontAwesomeIcon icon={faAngleDown} />
        </span>
      );
    }

    return "";
  };

  useEffect(() => {
    setSelected(isInitialSelected);
  }, []);

  const openClass = isOpen ? "is-open" : "";
  const selectedClass = hasSelected ? "has-selected" : "";

  return (
    <div className={`select-list form-group ${classList}`}>
      <span className="select-list__label" {...getLabelProps()}>
        {label}
      </span>
      <div className="select-list__wrapper">
        <div
          className={`select-list__toggle ${openClass}`}
          {...getToggleButtonProps()}
          onClick={() => (isEditable && !isOpen ? openMenu() : "")}
          role="button"
          tabIndex={0}
        >
          <div className={`select-list__selected-items ${selectedClass}`}>
            {selectedItem || initialInputValue}
          </div>
          {renderToggleButton()}
        </div>
        <ul
          className="select-list__items"
          role="listbox"
          {...getMenuProps()}
          style={!isOpen || !isEditable ? { display: "none" } : {}}
        >
          {renderListItems()}
        </ul>
      </div>
    </div>
  );
};

SelectList.propTypes = {
  /** Use this to turn off the "done" button if it's not necessary. */
  hasButton: PropTypes.bool,
  buttonText: PropTypes.string,
  isEditable: PropTypes.bool,
  classList: PropTypes.string,
  label: PropTypes.string.isRequired,
  initialInputValue: PropTypes.string.isRequired,
  /** Use this to set the initial selected item index. */
  initialIndex: PropTypes.number,
  /** Use this function to get the selected item back.  */
  sendItem: PropTypes.func,
  /** The component expects an array of child elements with unique keys. */
  children: PropTypes.node.isRequired
};

export default SelectList;
